export default __webpack_public_path__ + "static/media/close-secrets.831d3165.svg";